const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchEntregasVertical = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener entregas verticales');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchEntregasVertical:', error);
    throw error;
  }
};

export const fetchEntregasVerticalByEdificio = async (edificioId) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/edificio/${edificioId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener entregas del edificio');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchEntregasVerticalByEdificio:', error);
    throw error;
  }
};

export const createEntregaVertical = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al crear entrega vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createEntregaVertical:', error);
    throw error;
  }
};

export const updateEntregaVertical = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar entrega vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateEntregaVertical:', error);
    throw error;
  }
};

export const marcarEnCaminoVertical = async (ids, conductor) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/marcar-en-camino`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids, conductor }),
    });

    if (!response.ok) {
      throw new Error('Error al marcar entregas en camino');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en marcarEnCaminoVertical:', error);
    throw error;
  }
};

export const completarEntregaVertical = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/completar/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al completar entrega vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en completarEntregaVertical:', error);
    throw error;
  }
};

export const cancelarEntregaVertical = async (id, motivo, usuario) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria-vertical/cancelar/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ motivo, usuario }),
    });

    if (!response.ok) {
      throw new Error('Error al cancelar entrega vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en cancelarEntregaVertical:', error);
    throw error;
  }
};
